export function extractTenant(tenant: $TSFixMe) {
  return {
    id: tenant.id,
    name: tenant.name,
    description: tenant.description,
    public: tenant.public,
  };
}

export function extractTenants(rawTenants: $TSFixMe) {
  return rawTenants.tenants.map((tenant: $TSFixMe) => extractTenant(tenant));
}
